const baseApi = process.env.VUE_APP_BASE_API || '/app-api'
const adminBaseApi =
  process.env.VUE_APP_ADMIN_BASE_API || String(baseApi).replace(/\/app-api\/?$/, '/admin-api')

/** 高德 Web JS API（.env 变更后需重启 npm run serve） */
const amapWebKey = process.env.VUE_APP_AMAP_WEB_KEY || '2d81d8856213470df956523a4f003613'
const amapSecurityJsCode =
  process.env.VUE_APP_AMAP_SECURITY_JSCODE || 'bc3cb151e0e0e3a30ecee4e619f1f8f0'

export default {
  baseApi,
  adminBaseApi,
  amapWebKey,
  amapSecurityJsCode,
}
